module.exports = __webpack_public_path__ + "static/media/dnn.f1a25ee9.png";